
import "D:/Projects/Aimer/AimerPay/src/components/ActingAsMerchantBanner/index.less?modules";
export default {"exitBtn": `exitBtn-z9VWjUeg`,"banner": `banner-wVaXzcdX`,"info": `info-6P-U5FQ_`,"merchantName": `merchantName-Y98BTG57`}
